import { api } from "../api";

/**
 * customerDriverIdentifierExportResponse - Function that finds on database all customer drivers by status and export in a PDF/XSLX file  
 * /customers/{managerId}/{status}/{exportType}  
 * method GET  
 * @async-function
 */
const customerDriverIdentifierExportResponse = async (token: string, status: string, customerId: number, exportType: string, simpleXlsxExport = false) => {
    const response = await api.get(
        `/customers/${customerId}/drivers/export?status=${status}&type=${exportType}&simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default customerDriverIdentifierExportResponse;